import { buildJournalListingUrl } from './urlBuilder';

export const getRubricsNavigation = rubrics =>
  rubrics.map(rubric => ({
    title: rubric.title,
    route: buildJournalListingUrl(rubrics, rubric),
  }));



// WEBPACK FOOTER //
// ./src/shared/helpers/journal.js